
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/founding-advisors",
      function () {
        return require("private-next-pages/living/founding-advisors.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/founding-advisors"])
      });
    }
  